export default __webpack_public_path__ + "static/media/mars47.53a90dbd.gif";